import React, { useState, useEffect } from "react";
import { Button } from "devextreme-react/button";
import { Popup } from "devextreme-react/popup"; // Popup 컴포넌트 import
import Sidebar from "./components/Sidebar";
import TabContent from "./components/TabContent";
import LoginPage from "./pages/LoginPage";
import config from 'devextreme/core/config';
import { licenseKey } from './devextreme-license';
config({ licenseKey });

export default function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(() => !!localStorage.getItem("token"));
 // --- ★★★ [추가] 사이드바 열림/닫힘 상태 관리 ★★★ ---
 const [sidebarOpen, setSidebarOpen] = useState(true);

 

  // ★★★ [추가] 배포 후 캐시 갱신을 위한 자동 새로고침 로직 ★★★
  useEffect(() => {
    // 로그인이 안 된 상태(로그인 페이지 렌더링 전)일 때 실행
    if (!isLoggedIn) {
      const hasReloaded = sessionStorage.getItem("app_reloaded");
      
      // 세션에 리로드 기록이 없다면 (창을 새로 열었거나 처음 접속했을 때)
      if (!hasReloaded) {
        sessionStorage.setItem("app_reloaded", "true");
        
        // 캐시를 무시하고 강제로 서버에서 최신 index.html을 받아오게 하기 위해 
        // URL 뒤에 임의의 타임스탬프 파라미터를 붙여서 이동시킵니다.
        const currentUrl = window.location.origin + window.location.pathname;
        window.location.replace(`${currentUrl}?v=${new Date().getTime()}`);
      }
    }
  }, [isLoggedIn]);
  

  const [user, setUser] = useState(() => JSON.parse(localStorage.getItem("user") || 'null'));
  const [menuItems, setMenuItems] = useState(() => JSON.parse(localStorage.getItem("menuItems") || '[]'));
  
  const [tabs, setTabs] = useState(() => {
    const savedTabs = JSON.parse(localStorage.getItem("tabs") || '[]') || [];
    const savedMenuItems = JSON.parse(localStorage.getItem("menuItems") || '[]') || [];
    const homeTab = savedMenuItems.find(m => m.url === '/home');
    if (homeTab && !savedTabs.some(t => t.id === homeTab.id)) {
      return [homeTab, ...savedTabs];
    }
    if (savedTabs.length === 0 && homeTab) {
      return [homeTab];
    }
    return savedTabs;
  });

  const [selectedTab, setSelectedTab] = useState(() => {
    const savedTabs = JSON.parse(localStorage.getItem("tabs") || '[]') || [];
    const savedSelectedTab = JSON.parse(localStorage.getItem("selectedTab") || 'null');
    
    if (savedSelectedTab && savedTabs.some(t => t.id === savedSelectedTab.id)) {
      return savedSelectedTab;
    }
    const homeTab = savedTabs.find(t => t.url === '/home');
    if(homeTab) return homeTab;
    
    if (savedTabs.length > 0) {
      return savedTabs[0];
    }
    const savedMenuItems = JSON.parse(localStorage.getItem("menuItems") || '[]') || [];
    return savedMenuItems.find(m => m.url === '/home') || null;
  });
  



  // 로그아웃 확인 팝업의 표시 상태를 관리하는 state
  const [isLogoutPopupVisible, setIsLogoutPopupVisible] = useState(false);

  useEffect(() => {
    if (isLoggedIn) {
      localStorage.setItem("tabs", JSON.stringify(tabs));
      localStorage.setItem("selectedTab", JSON.stringify(selectedTab));
    }
  }, [isLoggedIn, tabs, selectedTab]);

  const handleLoginSuccess = (authorizedMenus, userInfo) => {
    const homeTab = authorizedMenus.find(menu => menu.url === '/home');
    
    localStorage.setItem("token", "dummy-token");
    localStorage.setItem("user", JSON.stringify(userInfo));
    localStorage.setItem("menuItems", JSON.stringify(authorizedMenus));
    if (homeTab) {
      localStorage.setItem("tabs", JSON.stringify([homeTab]));
      localStorage.setItem("selectedTab", JSON.stringify(homeTab));
    }
    
    setUser(userInfo);
    setMenuItems(authorizedMenus);
    if (homeTab) {
      setTabs([homeTab]);
      setSelectedTab(homeTab);
    }

    setIsLoggedIn(true);
  };

  // 로그아웃 버튼 클릭 시 팝업을 띄우는 함수
  const handleLogout = () => {
    setIsLogoutPopupVisible(true);
  };
  
  // 팝업에서 "Yes"를 눌렀을 때 실제 로그아웃을 처리하는 함수
  const confirmLogout = () => {
    localStorage.clear();
    sessionStorage.removeItem("app_reloaded"); // ★ 추가: 로그아웃 시 다시 새로고침 가능하도록 초기화
    setIsLoggedIn(false);
    setUser(null);
    setMenuItems([]);
    setTabs([]);
    setSelectedTab(null);
    setIsLogoutPopupVisible(false); // 팝업 닫기
  };

  // 자동 로그아웃 타이머
  useEffect(() => {
    if (!isLoggedIn) return;
    let timeoutId;
    const resetTimer = () => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        alert("30분간 활동이 없어 자동 로그아웃 되었습니다.");
        confirmLogout(); // 자동 로그아웃 시 확인 없이 바로 처리
      }, 30 * 60 * 1000);
    };
    const events = ['mousemove', 'keydown', 'click', 'scroll', 'touchstart'];
    events.forEach(event => window.addEventListener(event, resetTimer));
    resetTimer();
    return () => {
      clearTimeout(timeoutId);
      events.forEach(event => window.removeEventListener(event, resetTimer));
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoggedIn]);

  const handleSelectMenu = (item) => {
    if (!item || !item.url) return;
    
    const existingTab = tabs.find(tab => tab.id === item.id);
    if (existingTab) {
      setSelectedTab(existingTab);
    } else {
      setTabs([...tabs, item]);
      setSelectedTab(item);
    }
  };

  const handleCloseTab = (idToClose) => {
    const newTabs = tabs.filter(tab => tab.id !== idToClose);
    setTabs(newTabs);

    if (selectedTab && selectedTab.id === idToClose) {
      setSelectedTab(newTabs[newTabs.length - 1] || null);
    }
  };

  const handleCloseAllTabs = () => {
    const homeTab = menuItems.find(m => m.url === '/home');
    if (homeTab) {
      setTabs([homeTab]);
      setSelectedTab(homeTab);
    }
  };

  if (!isLoggedIn) {
    return <LoginPage onLoginSuccess={handleLoginSuccess} />;
  }

  return (
    <div style={{ height: "100vh", display: 'flex', flexDirection: 'column' }}>
      <header style={{ 
          height: '60px', 
          padding: "0 25px", 
          background: "#fff", 
          display: "flex", 
          justifyContent: "space-between", 
          alignItems: "center", 
          borderBottom: "1px solid #ddd", 
          flexShrink: 0 
      }}>
        <div style={{ fontSize: '1.4rem', fontWeight: 'bold' }}>WIP REPORT</div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
            <div style={{ fontSize: '16px' }}>
                <span>Welcome, </span>
                <span style={{ fontWeight: '600' }}>{user?.username}</span>
            </div>
            <Button text="Log out" type="danger" stylingMode="contained" onClick={handleLogout} />
        </div>
      </header>
      
  
      <div style={{ flex: 1, display: 'flex', overflow: 'hidden' }}>
        {/* --- ★★★ [수정] Sidebar에 sidebarOpen prop 전달 ★★★ --- */}
        <Sidebar 
            items={menuItems} 
            onSelect={handleSelectMenu} 
            sidebarOpen={sidebarOpen} 
        />
        
        {/* --- ★★★ [수정] TabContent에 토글 상태와 함수 전달 ★★★ --- */}
        <TabContent
          tabs={tabs}
          selected={selectedTab}
          onSelect={setSelectedTab}
          onClose={handleCloseTab}
          onCloseAll={handleCloseAllTabs}
          user={user}
          sidebarOpen={sidebarOpen}
          onToggleSidebar={() => setSidebarOpen(!sidebarOpen)}
        />
      </div>

      {/* 로그아웃 확인 팝업 컴포넌트 */}
      <Popup
        visible={isLogoutPopupVisible}
        onHiding={() => setIsLogoutPopupVisible(false)}
        dragEnabled={false}
        closeOnOutsideClick={true}
        showTitle={true}
        title="Confirm Logout"
        width={450} // 팝업 너비를 약간 늘림
        height="auto" // 높이를 내용에 맞게 자동으로 조절
        wrapperAttr={{ class: "logout-popup" }} // 팝업에 CSS 클래스 부여
      >
        <div style={{ textAlign: 'center', padding: '20px 0', fontSize: '16px' }}>
          Are you sure you want to log out?
        </div>
        {/* 버튼을 담는 컨테이너 스타일 수정 */}
        <div style={{ textAlign: 'center', marginTop: '30px' }}>
            <Button
                text="Yes, Log out"
                type="danger"
                stylingMode="contained" // 버튼 스타일을 더 명확하게
                width={140} // 버튼 너비를 넉넉하게
                onClick={confirmLogout}
                style={{ marginRight: '10px' }} // 버튼 사이 간격
            />
            <Button
                text="No"
                type="default"
                stylingMode="outlined" // "No" 버튼은 다른 스타일로
                width={140} // 버튼 너비를 넉넉하게
                onClick={() => setIsLogoutPopupVisible(false)}
            />
        </div>
      </Popup>
    </div>
  );
}